import { BlockchainID } from 'multirpc-sdk';
import { Chain } from '@ankr.com/chains-list';

import { getProjectPathsByChains } from './getProjectPathsByChains';
import { hasAllBlockchainsInWhitelist } from './hasAllBlockchainsInWhitelist';

export interface ProjectPathsParams {
  chains: Chain[];
  projectBlockchains: BlockchainID[];
}

export const getProjectPaths = ({
  chains,
  projectBlockchains,
}: ProjectPathsParams) => {
  if (hasAllBlockchainsInWhitelist(projectBlockchains)) {
    return getProjectPathsByChains(chains);
  }

  return projectBlockchains;
};
